import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

interface SearchIconWithPopupProps {
  size?: number;
  color?: string;
  className?: string;
  [key: string]: any;
}

export function SearchIconWithPopup(props: SearchIconWithPopupProps) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const { size, color, className, ...restProps } = props;

  const handleSearchSelect = (path: string) => {
    navigate(path);
    setShowModal(false);
  };

  return (
    <>
      <Search
        {...restProps}
        size={size}
        color={color}
        className={className}
        onClick={() => setShowModal(true)}
        style={{ cursor: "pointer", ...props.style }}
      />

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="sm"
      >
        <Modal.Header>
          <Modal.Title>Select Search Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-grid gap-2">
            <Button
              variant="primary"
              onClick={() => handleSearchSelect("/item-location-search")}
              className="mb-2"
            >
              Item/Location Search
            </Button>
            <Button
              variant="primary"
              onClick={() => handleSearchSelect("/inbound-storage-search")}
              className="mb-2"
            >
              Inbound Storage Search
            </Button>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SearchIconWithPopup;
